import { format } from "date-fns";
import { enUS } from "date-fns/locale";

/**
 * Matches moment().format('D. MMMM YYYY H:mm:ss') — e.g. "7. April 2026 14:30:45"
 * (day without leading zero, full month, 24h time).
 */
export function formatLiquidCrystalDateTime(date = new Date()) {
  const day = date.getDate();
  const tail = format(date, "MMMM yyyy HH:mm:ss", { locale: enUS });
  return `${day}. ${tail}`;
}
